import { reactive } from 'vue'

class MathliveState {
    isShow = false
    latex = ""
    oldLatex = ""
    onFinish: (latex: string) => void

    show(latex = '', onFinish: (latex: string) => void) {
        this.latex = latex
        this.oldLatex = latex
        this.isShow = true
        this.onFinish = onFinish
    }

    cancel() {
        this.isShow = false
        this.onFinish(this.oldLatex)
    }

    hide() {
        this.isShow = false
        this.onFinish(this.latex)
    }

    setLatex(latex: string) {
        this.latex = latex
    }

}

// Wrap the class instance with Vue 3's reactive() for reactivity
export const mathliveState = reactive(new MathliveState()) as MathliveState